import { redirect } from "@tanstack/react-router";
import type { RouterContext } from "@/router";

export function requireAuth({
  context,
  location,
}: {
  context: RouterContext;
  location: { href: string };
}) {
  if (!context.auth.isAuthenticated) {
    throw redirect({
      to: "/login",
      search: { returnTo: location.href },
    });
  }
}
